import { observer } from 'src/utils/mobx-react';

import {
    OverlayDefault,
    Content,
    PopupHeader,
    AcceptBtn,
    TermsBoxStaticPageContent,
} from 'src/domains/players/webview/components/Account/BlockingNotifications/BlockingNotifications.style';
import React from 'react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { Policy } from 'src/domains/players/webview/components/Account/resetPasswordProcedure/resetPasswordForm/Policy';
import { UniverseComponent } from 'src/domains/common/universes';
import { useAppStateContext } from 'src/appState/AppState';

interface StaticPageContentPropsType {
    id: string;
}

export const StaticPageContent = observer(
    'StaticPageContent',
    ({ id }: StaticPageContentPropsType): JSX.Element | null => {
        const {
            appLayoutsState: { starRouter },
        } = useAppStateContext();

        return (
            <OverlayDefault data-test='overlay-prompt'>
                <Content>
                    <UniverseComponent>
                        {(universeModule): React.ReactElement => <universeModule.compliancePopupLogo />}
                    </UniverseComponent>
                    <PopupHeader>
                        {id === 'privacy-policy' ? (
                            <I18n
                                langKey='account.privacy-policy.title'
                                defaultText='Privacy Policy'
                            />
                        ) : null}
                        {id === 'terms-and-conditions' ? (
                            <I18n
                                langKey='account.terms-notification.title'
                                defaultText='Terms and Conditions'
                            />
                        ) : null}
                    </PopupHeader>

                    <TermsBoxStaticPageContent>
                        <Policy
                            leftAlign
                            id={id}
                        />
                    </TermsBoxStaticPageContent>

                    <AcceptBtn
                        onClick={starRouter.redirectToHomepage}
                        size='medium'
                    >
                        <I18n
                            langKey='account.terms-notification.home-button.label'
                            defaultText='Home'
                        />
                    </AcceptBtn>
                </Content>
            </OverlayDefault>
        );
    }
);
